<div class="flex-row flex">
    <form class="flex-row flex" #houseLandSpecForm="ngForm">
        <div class="flex-col flex">
            <div class="cb-margin end start flex-row" style="margin-bottom: -10px">
                <cb-input
                    type="text"
                    name="noBedrooms"
                    label="Lot Spec Version"
                    [readonly]="true"
                    class="amenities"
                    [(ngModel)]="mappedItem.specVersion"
                >
                </cb-input>
                <span class="flex"></span>
                @if (!isAllAccordionItemsExpanded) {
                    <button mat-raised-button color="primary" (cbClick)="expandAllItems()">
                        <span>
                            Expand All&nbsp;
                            <mat-icon style="vertical-align: middle">keyboard_arrow_down</mat-icon>
                        </span>
                    </button>
                }
                @if (isAllAccordionItemsExpanded) {
                    <button mat-raised-button color="primary" (cbClick)="collapseAllItems()">
                        <span>
                            Collapse All&nbsp;
                            <mat-icon style="vertical-align: middle">keyboard_arrow_up</mat-icon>
                        </span>
                    </button>
                }
            </div>
            <div class="accordion-container">
                <mat-accordion multi="true" style="display: block" #firstAccordion="matAccordion">
                    @for (group of mappedItem.$areas; track group) {
                        <mat-expansion-panel
                            class="flex"
                            [(expanded)]="group.expanded"
                            (expandedChange)="expandedChange($event)"
                        >
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <span class="mat-body-strong">{{ getAreaTitle(group) }}</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="flex-col flex">
                                <cb-table
                                    class="flex"
                                    label="Lot Spec Items"
                                    [stringColumns]="displayedColumns"
                                    [loaded]="true"
                                    emptyMessage="There are no Items in this House Area"
                                >
                                    @for (
                                        theItem of getItemsForHouseArea(group.id);
                                        track theItem
                                    ) {
                                        <tr cbTableRow>
                                            @if (!theItem.item.colourItem) {
                                                <td>{{ theItem.displayText }}</td>
                                                <td>
                                                    @if (
                                                        theItem.item.offeringOptions &&
                                                        theItem.item.offeringOptions.length > 0
                                                    ) {
                                                        <ul class="inline-list">
                                                            @for (
                                                                opt of theItem.item.offeringOptions;
                                                                track opt
                                                            ) {
                                                                <li>
                                                                    {{ opt.name }}
                                                                </li>
                                                            }
                                                        </ul>
                                                    }
                                                    @if (
                                                        !theItem.item.offeringOptions ||
                                                        theItem.item.offeringOptions.length < 1
                                                    ) {
                                                        <span class="inline-list">-</span>
                                                    }
                                                </td>
                                                <td>{{ getQuantity(theItem.item) }}</td>
                                            }
                                            @if (theItem.item.colourItem) {
                                                <td>{{ theItem.displayText }}</td>
                                                <td>-</td>
                                                <td>-</td>
                                            }
                                        </tr>
                                    }
                                </cb-table>
                            </div>
                        </mat-expansion-panel>
                    }
                </mat-accordion>
            </div>
        </div>
    </form>
</div>
